'use client';
import { FC, PropsWithChildren } from 'react';

import { useDesignsTokenTheme } from '@web/ui/theme/ThemeProvider';

import { SplashScreen } from './index';

export const SplashGuard: FC<
  PropsWithChildren<{
    guardIf?: boolean;
  }>
> = ({ children, guardIf }) => {
  const { isThemeLoaded } = useDesignsTokenTheme();

  if (!isThemeLoaded) return <SplashScreen />;

  if (guardIf === true) return <SplashScreen />;

  return <>{children}</>;
};
